// extracted by mini-css-extract-plugin
module.exports = {"leadtext":"StorylineLeadText_leadtext__p5ihZ"};